// @flow
/** @jsx h */
import { Fragment, h, VNode } from 'preact';
import { styled } from 'goober';
import WebFont from 'webfontloader';
import { useEffect } from 'preact/hooks';
import icLogo from '../../assets/telesales/instacred.svg';

const ParentContainer = styled('div')`
  * {
    font-family: 'Inter', sans-serif;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #fff;
  height: 100dvh;

  @media (max-width: 414px) {
    justify-content: space-between;
  }
`;

const Header = styled('div')`
  display: flex;
  height: 48px;
  background: #fff;
  box-shadow: 1px 1px 6px 0px rgba(174, 174, 174, 0.25);
  padding: 0 28px;
  width: 100%;
  align-items: center;
  position: fixed;

  @media (min-width: 769px) {
    max-width: 414px;
  }

  .icLogo {
    height: 20px;
  }
`;

type RequestPaymentContainerProps = {
  children: VNode,
};

const RequestPaymentContainer = ({
  children,
}: RequestPaymentContainerProps) => {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Inter:400,500,600,700'],
      },
    });
  }, []);

  return (
    <ParentContainer>
      <Header>
        <img src={icLogo} className='icLogo' alt='instacred logo' />
      </Header>
      <Fragment>{children}</Fragment>
    </ParentContainer>
  );
};

export default RequestPaymentContainer;



// WEBPACK FOOTER //
// ./components/telesalesComponenets/RequestPaymentContainer.js